import React, { Component } from "react";
import { Collapse } from "react-bootstrap";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import CallMenu from "./call-menu.js";
import moment from "moment-timezone";
import {
  getOutgoingCalls,
  getIncomingCalls,
  setOutgoingCalls,
} from "../actions/getCalls";
import { doCall, showWebphone } from "../actions/call";
import CallsModal from "./modals/callsModal";
import { logData } from "../utils/utils.js";
import "../agent/Styles/darktheme.css";
import "../agent/Styles/blacktheme.css";
import "../agent/Styles/highContrast.css";

class OutgoingPanel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: true,
      showCallsModal: false,
      columns: [
        {
          title: "hour",
          key: "begin_date",
          time: true,
          style: { width: "165px" },
        },
        {
          title: "service",
          key: "service",
          style: { width: "165px" },
          filter: true,
        },
        {
          title: "number",
          key: "destination_phone",
          doCall: true,
          style: { width: "165px" },
          filter: true,
        },
        {
          title: "region",
          key: "geographic_zone",
          style: { width: "165px" },
          filter: true,
        },
        {
          title: "onCall",
          key: "speaking",
          operation: "subtract",
          firstItem: "end_date",
          secondItem: "answer_date",
          style: { width: "100px" },
        },
        {
          title: "duration",
          key: "duration",
          operation: "subtract",
          firstItem: "end_date",
          secondItem: "begin_date",
          style: { width: "100px" },
        },
      ],
      startX: 0,
      startY: 0,
      didMove: false,
      link_disabled: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.outgoingEvent !== this.props.outgoingEvent) {
      setTimeout(() => {
        this.getOutgoingCallsList();
      }, 5000);
    }
  }

  // gets call list
  getOutgoingCallsList = () => {
    this.props.getOutgoingCalls().then(
      (res) => {},
      (err) => {
        logData(err);
      }
    );
  };

  // refreshes calls
  refreshCalls = () => {
    this.props.getIncomingCalls();
    this.props.getOutgoingCalls();
  };

  close = (key) => {
    this.setState({ [key]: false });
  };
  // opens modal
  open = (key) => {
    this.setState({ [key]: true });
  };

  handleMouseDown = (event) => {
    this.setState({
      startX: event.pageX,
      startY: event.pageY,
      didMove: false,
    });
  };
  handleMouseUp = (event) => {
    const deltaX = event.pageX - this.state.startX;
    const deltaY = event.pageY - this.state.startY;
    const euclidean = Math.sqrt(deltaX * deltaX + deltaY * deltaY);

    this.setState({
      didMove: euclidean > 5, // radiusLimit = 5
    });
    // console.log(this.state.didMove);
  };

  handleClick = (item) => (e) => {
    if (!this.state.didMove) {
        if (! this.state.link_disabled)
        {
            // console.log('CLICK no more!! Panel Llamadas salientes');
            this.state.link_disabled = true;
            setTimeout(() => { 
                this.state.link_disabled = false;
                // console.log('CLICK ok!! Panel Llamadas salientes');
            }, 5000);
    
            // console.log('LLAMAR POR OUTGOING PANEL');

            this.props.showWebphone(true);    
            const payload = {
                phoneNumber: item.destination_phone,
            };
            this.props.doCall(payload);
        }
    }
  };

  // makes phone call
  // handleCall = (e) => {
  // 	const payload = {
  // 		phoneNumber: e.target.id
  // 	};
  // 	this.props.doCall(payload);
  // }

  /**
   * updates call list with updated end business
   * @param  {string} callId
   * @param  {string} end_business_id
   * @param  {string} end_business    name of end business
   */
  outgoingServiceCb = (callId, end_business_id, end_business) => {
    const calls = this.props.outgoingCalls.map((item) =>
      item.call_id !== callId
        ? item
        : { ...item, end_business_id, end_business }
    );
    this.props.setOutgoingCalls(calls);
  };
  // updates schedule date for current calls.
  rescheduleCallCb = (callId, schedule_date, schedule_service) => {
    const calls = this.props.outgoingCalls.map((item) =>
      item.call_id !== callId
        ? item
        : { ...item, schedule_date, schedule_service }
    );
    this.props.setOutgoingCalls(calls);
  };

  renderCalls = () => {
    return this.props.outgoingCalls.slice(0, 5).map((item) => {
      return (
        <tr key={item.call_id}>
          <td>
            {moment
              .tz(item.begin_date * 1000, this.props.agentInfo.timezone)
              .format("HH:mm")}
          </td>
          <td style = {{whiteSpace: "nowrap"}}>{item.service}</td>
          <td
            style={{ maxWidth: 120, wordBreak: "break-all", whiteSpace: "nowrap" }}
            className="cursor handle-call"
            id={item.destination_phone}
            onMouseDown={this.handleMouseDown}
           	onMouseUp={this.handleMouseUp}
						onClick={this.handleClick(item)}
            
          >
            {item.destination_phone}
          </td>
          <td style={{width:"80px"}} >
            <CallMenu
              CallId={item.call_id}
              phoneNumber={item.destination_phone}
              serviceId={item.service_id}
              disableOptions={item.end_business_id !== 0}
              endBusinessId={item.end_business_id}
              endBusiness={item.end_business}
              getCalls={this.refreshCalls}
              has_tags={item.has_tags}
              outgoingServiceCb={this.outgoingServiceCb}
              rescheduleCallCb={this.rescheduleCallCb}
              scheduleDate={item.schedule_date}
              scheduleService={item.schedule_service || ""}
              listDetailId={item.list_detail_id}
              type="outgoing"
            />
          </td>
        </tr>
      );
    });
  };

  render() {
    const { translations, selectedLanguage } = this.props;
    return (
      <div
        className={`panel${this.props.theme} panel-default${this.props.theme}`}
      >
        <div className={`panel-heading panel-heading${this.props.theme}`}>
          <h3 className="panel-title">
            <a
              className="show btn-icon"
              onClick={() => this.setState({ open: !this.state.open })}
            >
              <span className="icon icon-log-out icon-right-space"></span>
              <span className="anchor_text">
                {translations.outgoingCalls[selectedLanguage]}
              </span>
              <span className="icon icon-select-arrows pull-right"></span>
            </a>
          </h3>
        </div>
        <Collapse in={this.state.open}>
          <div>
            <ul className="padding-0 margin-bottom-0">
              {this.props.outgoingCalls.length > 0 && (
                <div>
                  <div>
                    <table
                      className={`table table${this.props.theme} table-condensed table-hover${this.props.theme} small m-a-0`}
                    >
                      <thead>
                        <tr>
                          <th>{translations.hour[selectedLanguage]}</th>
                          <th>{translations.service[selectedLanguage]}</th>
                          <th>{translations.phoneNumber[selectedLanguage]}</th>
                          <th style={{ maxWidth: 56, width: 56 }} />
                        </tr>
                      </thead>
                      <tbody>{this.renderCalls()}</tbody>
                    </table>
                  </div>
                </div>
              )}
              {this.props.outgoingCalls.length == 0 && (
                <div className="panel-body text-center small">
                  {translations.noOutgoingCalls[selectedLanguage]}
                </div>
              )}
            </ul>
            <ul className="list-group link-list margin-bottom-0">
              <li
                className={`list-group-item compress text-center border-top${this.props.theme} a${this.props.theme}`}
              >
                <a
                  onClick={() => this.open("showCallsModal")}
                  className="show"
                  data-toggle="modal"
                  data-target="#tableModal"
                >
                  {translations.seeMore[selectedLanguage]}
                </a>
              </li>
            </ul>
          </div>
        </Collapse>
        <CallsModal
          type="outgoing"
          callAction="getOutgoingCalls"
          callDataParam="items"
          columns={this.state.columns}
          callsData={this.props.outgoingCalls}
          showCallsModal={this.state.showCallsModal}
          has_tags={this.state.has_tags}
          handleClose={() => this.close("showCallsModal")}
          headerText={translations.outgoingCalls[selectedLanguage]}
          callMenuProps={this.state.callMenuProps}
          panelOutgoingServiceCb={this.outgoingServiceCb}
          panelRescheduleCallCb={this.rescheduleCallCb}
          panelGetCalls={this.refreshCalls}
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    outgoingCalls: state.outgoingCalls,
    agentInfo: state.agentInfo,
    outgoingEvent: state.callEvents.outgoing,
    translations: state.languages.translations,
    selectedLanguage: state.languages.selectedLanguage,
    darkMode: state.common.darkMode,
    theme: state.common.theme,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    { getOutgoingCalls, getIncomingCalls, setOutgoingCalls, doCall, showWebphone },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(OutgoingPanel);



// WEBPACK FOOTER //
// ./src/agent/outgoing-panel.js